import * as v from "valibot";

// request
export const RequestSchema = v.object({
  Action: v.nullish(v.string()),
  ClusterId: v.string(),
  Version: v.nullish(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const ClusterComponentStatusSchema = v.object({
  ComponentName: v.string(),
  ErrorPodIps: v.nullish(v.array(v.string())),
  Status: v.string(),
  UpdateProcess: v.number(),
  UpdateStatus: v.string(),
});
export type ClusterComponentStatus = v.InferOutput<typeof ClusterComponentStatusSchema>;

export const DataSchema = v.object({
  ClusterComponentStatus: v.array(ClusterComponentStatusSchema),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
